<template>
  <div>
    <div class="row">
      <div class="col d-flex">
        <div class="flex-grow-1 mr-1">
          <b-form-input
            v-model="modelSearch"
            @keyup.enter.prevent="$emit('search', 1)"
            placeholder="Pesquisar"
          />
        </div>

        <slot name="append"></slot>

        <div class="d-flex flex-nowrap">
          <b-button
            variant="outline-danger"
            @click="clearFilters"
            :disabled="!hasActiveFilter"
            class="mr-1"
          >
            <b-icon icon="x" />
            Limpar filtros
          </b-button>
          <b-button @click="$emit('search', 1)" variant="bagsis"
            >Buscar</b-button
          >
        </div>
      </div>
    </div>
    <div
      v-if="showAdvancedSearch"
      class="mt-2 pt-4 px-3 pb-2 border rounded position-relative"
    >
      <form-more-filters v-model="modelFilters" />
    </div>
  </div>
</template>
<script>
import FormMoreFilters from "@/modules/files/Components/Form/FormMoreFilters.vue";

export default {
  components: {
    FormMoreFilters,
  },
  props: {
    search: {
      type: String,
      default: "",
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
    externalValidFilters: {
      type: Boolean,
      default: true,
    },
    showAdvancedSearch: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["clear", "update:search", "update:filters", "search"],
  computed: {
    modelSearch: {
      get() {
        return this.search;
      },
      set(value) {
        this.$emit("update:search", value);
      },
    },
    modelFilters: {
      get() {
        return this.filters;
      },
      set(value) {
        this.$emit("update:filters", value);
      },
    },
    hasSearchText() {
      return this.search && this.search.length > 0;
    },
    hasActiveFilter() {
      const filterKeys = Object.keys(this.filters || {});
      const verifyFilterItem = (key) => Boolean(this.filters[key]);
      const hasValidFilter = filterKeys.some(verifyFilterItem);

      return this.externalValidFilters || this.hasSearchText || hasValidFilter;
    },
  },
  methods: {
    clearFilters() {
      this.modelSearch = null;
      this.$emit("clear");
    },
  },
};
</script>
